import React from 'react'
import coordimobilbarStyle from './CoordinatorMobilPageBar.module.css'
import { Link, useNavigate } from 'react-router-dom';
require('typeface-poppins')

export default function CoordinatorMobilPageBar() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/coordinator-dashboard');
  };

  return (
    <>
      <div className={`${coordimobilbarStyle.coordimobilpagebar}`}>
        <div className={`${coordimobilbarStyle.coordinatorMobilbar} d-flex flex-wrap align-items-center`}>
          <Link
            className={coordimobilbarStyle.coordinatorMobilTitle}
            onClick={(e) => { e.preventDefault(); handleBack(); }}
          >
            Back
          </Link>
        </div>
      </div>
    </>
  )
}
